import { consola } from 'consola'

const logger = consola.withTag('sentry-user')

/**
 * Привязка ошибок к пользователю в GlitchTip/Sentry.
 *
 * Без setUser события прилетают анонимными, и поддержка не может показать админу
 * «какие баги были у ЭТОГО гостя» — выборка `user.id:<id>` в тикете пустая.
 *
 * Sentry подключается только в production-сборке (см. nuxt.config), поэтому
 * импорт динамический: в dev модуля просто нет, и это не ошибка.
 * Персональные данные не отправляем — только id: телефон и имя админ и так видит
 * в карточке тикета, а в трекере ошибок им делать нечего.
 */
export async function setMonitoringUser(userId: number | string | null): Promise<void> {
  if (!import.meta.client) return
  try {
    const Sentry = await import('@sentry/nuxt').catch(() => null)
    if (!Sentry?.setUser) return
    Sentry.setUser(userId ? { id: String(userId) } : null)
  } catch (error) {
    logger.debug('Не удалось привязать пользователя к мониторингу:', error)
  }
}
